import api from '@/api'

const state = {
  isAddressModalVisible: false,
  addressModalMode: null,
  selectedAddressId: null,
  addresses: [],
  addressDetail: {},
  deliveryServices: [],
  deliveryServicesPickup: [],
  nearestHub: null,
  merchantUsers: [],
  userDetail: {},
  mitraDetail: {},
  vouchers: [],
  voucherList: {
    items: [],
    total_items: 0,
    page: 1,
    limit: 10,
    total_pages: 0
  }
}
const actions = {
  toggleAddressModal({ commit }, options) {
    commit('setAddressModalStatus', options.state)
    commit('setAddressModalMode', options.mode)
    if (options.addressId) commit('setSelectedAddressId', options.addressId)
  },
  merchantRegistration({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.registration(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  setPassword({ _ }, { token, payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.setPassword(token, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getAddresses({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.addresses(params).then(
        response => {
          commit('setAddresses', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getAddressDetail({ commit }, { addressId }) {
    return new Promise((resolve, reject) => {
      api.merchant.addressDetail(addressId).then(
        response => {
          commit('setAddressDetail', response.data.data)
          resolve(response.data.data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  addAddress({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.addAddress(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  editAddress({ _ }, { addressId, payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.editAddress(addressId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  removeAddress({ _ }, { addressId }) {
    return new Promise((resolve, reject) => {
      api.merchant.removeAddress(addressId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  geocodingReverse({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.geocodingReverse(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDeliveryServices({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.deliveryServices(params).then(
        response => {
          commit('setDeliveryServices', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getMerchantUsers({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.users(params).then(
        response => {
          commit('setMerchantUsers', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getMerchantUserDetail({ commit }, { userId }) {
    return new Promise((resolve, reject) => {
      api.merchant.userDetail(userId).then(
        response => {
          commit('setMerchantUserDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateMerchantUser({ _ }, { userId, payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.updateUser(userId, payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  deleteMerchantUser({ _ }, { userId }) {
    return new Promise((resolve, reject) => {
      api.merchant.deleteUser(userId).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createMerchantUser({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.createMerchantUser(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getDeliveryServicesPickup({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.deliveryServices(params).then(
        response => {
          commit('setDeliveryServicesPickup', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getNearestHub({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.nearestHub(params).then(
        response => {
          commit('setNearestHub', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createOrder({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.createOrder(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getMitraDetail({ commit }, { externalId }) {
    return new Promise((resolve, reject) => {
      // Menambahkan timestamp agar browser selalu meminta data segar dari server
      const cb = new Date().getTime()
      api.merchant.getMitraDetail(`${externalId}?t=${cb}`).then(
        response => {
          const data = response.data.data
          commit('setMitraDetail', data)
          resolve(data)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  updateMitraDetail({ dispatch }, { externalId, payloads }) {
    return new Promise((resolve, reject) => {
      api.merchant.updateMitra(externalId, payloads).then(
        response => {
          dispatch('getMitraDetail', { externalId })
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getVouchers({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.vouchers(params).then(
        response => {
          commit('setVouchers', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getVouchersPagination({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.merchant.vouchersPagination(params).then(
        response => {
          commit('setVoucherList', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setAddresses(state, value) {
    state.addresses = value
  },
  setAddressDetail(state, value) {
    state.addressDetail = value
  },
  setDeliveryServices(state, value) {
    state.deliveryServices = value
  },
  setDeliveryServicesPickup(state, value) {
    state.deliveryServicesPickup = value
  },
  setNearestHub(state, value) {
    state.nearestHub = value
  },
  setAddressModalStatus(state, value) {
    state.isAddressModalVisible = value
  },
  setAddressModalMode(state, value) {
    state.addressModalMode = value
  },
  setSelectedAddressId(state, value) {
    state.selectedAddressId = value
  },
  setMerchantUsers(state, value) {
    state.merchantUsers = value
  },
  setMerchantUserDetail(state, value) {
    state.userDetail = value
  },
  setMitraDetail(state, value) {
    state.mitraDetail = value
  },
  setVouchers(state, value) {
    state.vouchers = value
  },
  setVoucherList(state, value) {
    state.voucherList = value
  }
}
const getters = {
  addresses: state => state.addresses,
  addressDetail: state => state.addressDetail,
  deliveryServices: state => state.deliveryServices,
  deliveryServicesPickup: state => state.deliveryServicesPickup,
  nearestHub: state => state.nearestHub,
  isAddressModalVisible: state => state.isAddressModalVisible,
  addressModalMode: state => state.addressModalMode,
  selectedAddressId: state => state.selectedAddressId,
  merchantUsers: state => state.merchantUsers,
  userDetail: state => state.userDetail,
  mitraDetail: state => state.mitraDetail,
  vouchers: state => state.vouchers,
  voucherList: state => state.voucherList
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}